import { render, staticRenderFns } from "./SlotModal.vue?vue&type=template&id=8fabaaa8&scoped=true&lang=pug"
import script from "./SlotModal.vue?vue&type=script&lang=ts"
export * from "./SlotModal.vue?vue&type=script&lang=ts"
import style0 from "./SlotModal.vue?vue&type=style&index=0&id=8fabaaa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fabaaa8",
  null
  
)

export default component.exports